package com.neurobs.ccabserver.translationadmin.components.testupload.components

import com.neurobs.ccab.translation.{CCABDiffData, ExistingTest, TestDiffData}
import com.neurobs.ccabserver.translationadmin.states.TestUploadStateGenerator
import com.neurobs.react.{ReactElementFactory, ReactUtil}
import com.neurobs.react.semanticui.{UiDividerFactory, UiGridFactory, UiHeaderFactory, UiLoaderFactory, UiMessageFactory}
import org.scalajs.dom.console
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html._

import scala.scalajs.js

@react
object CCABDiff {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val testUploadState = TestUploadStateGenerator.accessState

    def isFileUploaded = testUploadState.uploadedFileState.value.isDefined


    if (!isFileUploaded) null
    else {
      props.enclosingElement(
        Seq[ReactElement](
          testUploadState.ccabDiffState.value match {
            case Left(errorOpt) => errorOpt match {
              case None => UiLoaderFactory.ActiveTextLoader("Analyzing CCAB changes")
              case Some(error) => UiMessageFactory.BasicErrorMessage(error)
            }
            case Right(ccabDiff) => CCABDiffView(ccabDiff)
          }
        )
      )
    }
  }

}

@react
object CCABDiffView {
  case class Props(ccabDiff: CCABDiffData)
  val component = FunctionalComponent[Props] { props =>

    def columnStyle = Seq[(String, js.Any)](("maxHeight", "300px"), ("overflowY", "auto"))
    def containerDivStyle = Seq[(String, js.Any)](
      ("marginBottom", "15px"), ("borderBottom", "1px solid"), ("paddingBottom", "15px")
    )

    UiGridFactory.Grid(
      if (props.ccabDiff.alteredTests.length == 0) null
      else {
        UiGridFactory.GridColumn(
          UiHeaderFactory.TextHeader("Phrase changes by test", 3),
          props.ccabDiff.alteredTests.map(
            AlteredTestView(
              _,
              ReactElementFactory.Div(_)(containerDivStyle)
            )
          )
        )(("eleven wide center aligned", columnStyle))
      },
      if (props.ccabDiff.newTests.length + props.ccabDiff.outdatedTests.length == 0) null
      else {
        UiGridFactory.GridColumn(
          UiHeaderFactory.TextHeader("Test additions and removals", 3),
          NewAndOutdatedTestView(
            props.ccabDiff.newTests,
            props.ccabDiff.outdatedTests,
            ReactElementFactory.Div(_)
          )
        )(("five wide center aligned", columnStyle))
      },
      if (props.ccabDiff.isUnchanged) {
        UiGridFactory.GridColumn(
          UiMessageFactory.BasicMessage("The uploaded version of the CCAB matches the most recent database version.")
        )("sixteen wide center aligned")
      }
      else null
    )
  }
}

@react
object NewAndOutdatedTestView {
  case class Props(newTests: List[TestDiffData], outdatedTests: List[ExistingTest], enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    def addedTestStyle = Seq[(String, js.Any)](("color", "green"))
    def outdatedTestStyle = Seq[(String, js.Any)](("color", "red"))

    props.enclosingElement(
      Seq[ReactElement](
        props.newTests.map(newTest => {
          UiHeaderFactory.TextHeader("+ " + newTest.testIdentifier, 5)(addedTestStyle)
        }),
        props.outdatedTests.map(outdatedTest => {
          UiHeaderFactory.TextHeader("- " + outdatedTest.testIdentifier, 5)(outdatedTestStyle)
        })


      )
    )

  }
}

@react
object AlteredTestView {
  case class Props(alteredTest: TestDiffData, enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props]  { props =>

    def addedPhraseStyle = Seq[(String, js.Any)](("color", "green"))
    def outdatedPhraseStyle = Seq[(String, js.Any)](("color", "red"))

    props.enclosingElement(
      Seq[ReactElement](
        UiHeaderFactory.TextHeader(props.alteredTest.testIdentifier, 4),
        props.alteredTest.newPhrases.map(phrase => {
          ReactElementFactory.P("+ " + phrase.uploadPhrase.phrase)(addedPhraseStyle)
        }),
        props.alteredTest.outdatedPhrases.map(phrase => {
          ReactElementFactory.P("- " + phrase.text)(outdatedPhraseStyle)
        })
      )
    )
  }
}